import { Dispatch, SetStateAction } from 'react';

export const onTrpcError = (setError: Dispatch<SetStateAction<string>>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (e: any) => {
    try {
      const parsedErrors = JSON.parse(e.message);
      let s = '';
      for (const e of parsedErrors) {
        if (e.message.includes('String')) {
          s += `${e.message.replace('String', e.path[0])}\n`;
        } else {
          s += `${e.message} ${e.path[0]}\n`;
        }
      }
      setError(s);
    } catch {
      setError(e.message);
    }
  };
};

export const formatTime = (start: number, end: number) => {
  const startStr =
    start === 0
      ? '12:00 AM'
      : start < 12
        ? `${start}:00 AM`
        : `${start - 12 === 0 ? 12 : start - 12}:00 PM`;
  const endStr =
    end === 0
      ? '12:00 AM'
      : end === 24
        ? '11:59 PM'
        : end < 12
          ? `${end}:00 AM`
          : `${end - 12 === 0 ? 12 : end - 12}:00 PM`;
  return `${startStr} - ${endStr}`;
};
